<h2 mat-dialog-title>Verortung Sensoren – Konfiguration</h2>
<mat-dialog-content [formGroup]="form">
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>Überschrift</mat-label>
    <input matInput formControlName="headline" />
  </mat-form-field>

  <div class="d-flex justify-content-end mb-2">
    <mat-checkbox
      formControlName="allDatasourcesChecked"
      (change)="onAllDatasourcesCheckedChange($event)"
      >
      Alle auswählen
    </mat-checkbox>
  </div>

  <div formArrayName="datasources" class="sensor-list">
    @for (ds of datasourcesFromFormGroup().controls; track ds; let i = $index) {
      <div
        class="sensor-item"
        [formGroupName]="i"
        >
        <mat-checkbox formControlName="checked">{{
          ds.get("name").value
        }}</mat-checkbox>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Abbrechen</button>
  <button
    mat-flat-button
    color="primary"
    (click)="updateOrCreateModule()"
    [disabled]="!form.valid || submitting"
    >
    Speichern
  </button>
</mat-dialog-actions>
